module.exports = __webpack_public_path__ + "img/israel_flag.d475a3b0.png";